import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../Period'
import AddResultPopup from '../sub-screen/add-result-popup/AddResultPopup'
import CalculateRewardPopup from '../sub-screen/calculate-reward-popup/CalculateRewardPopup'
import { getList } from '../../../../controller/api/__loto__/result'
import { calculatePage } from '../../../../helper/helper'
import { useCookies } from 'react-cookie'

const _Table = () => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong'])

  const [addPopupShow, setAddPopupShow] = useState(false)

  const [modalCalculateRewardShow, setModalCalculateRewardShow] = useState(false)

  const resultIdRef = useRef(null)

  const resultRef = useRef(null)

  const periodRef = useRef(null)

  const refreshData = useCallback(async () => {
    dispatch({
      type: 'SET_LOADING',
      payload: true
    })

    try {
      const response = await getList(cookies.lottmekong, {
        from: state.filter.from,
        to: state.filter.to,
      }, state.filter.page)

      if (response) {
        dispatch({
          type: 'UPDATE_DATA',
          payload: {
            list: response.data,
            total: response.total,
            classicUser: response.classicUser,
            totalPage: calculatePage(response.total)
          }
        })
      }
    } finally {
      dispatch({
        type: 'SET_LOADING',
        payload: false
      })
    }
  }, [cookies.lottmekong, dispatch, state.filter.from, state.filter.page, state.filter.to])

  const onShowAddPopupPress = (id, result) => {
    resultIdRef.current = id
    resultRef.current = result
    setAddPopupShow(true)
  }

  const onShowCalculateRewardPopupPress = (resultId, period) => {
    resultIdRef.current = resultId
    periodRef.current = period
    setModalCalculateRewardShow(true)
  }

  const onHideCalculateRewardPopupPress = (totalRewardTicket, totalUnrewardTicket, callback) => {
    callback()
    setModalCalculateRewardShow(false)
    refreshData()
    resultIdRef.current = null
    periodRef.current = null
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Thông tin</th>
              <th scope="col">Kết quả</th>
              <th scope="col">Số lượng vé</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.length > 0 ? (
              state.data.list.map((pv, index) =>
              <TableRow
                onCalculateRewardPress={onShowCalculateRewardPopupPress}
                handleAddResult={onShowAddPopupPress}
                rIndex={index}
                key={`table-keys-lottmekong-${pv.id}`}
                {...pv}
              />
              )
            ) : (
              <tr>
                <td colSpan={6} className="text-center py-5 text-muted">
                  Không có dữ liệu
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <AddResultPopup
        show={addPopupShow}
        id={resultIdRef.current}
        result={resultRef.current}
        onHide={() => {
          resultIdRef.current = null
          setAddPopupShow(false)
        }}
      />
      <CalculateRewardPopup
        show={modalCalculateRewardShow}
        resultId={resultIdRef.current}
        period={periodRef.current}
        onHide={onHideCalculateRewardPopupPress}
      />
    </>
  );
};

export default React.memo(_Table)
